import PortfolioDeleteModal from "./PortfolioDeleteModal";

export default PortfolioDeleteModal;
